import { Shield, Clock, MapPin } from "lucide-react";

const TrustBanner = () => {
  const stats = [
    {
      icon: Clock,
      number: "16+",
      label: "Years Experience",
    },
    {
      icon: Shield,
      number: "Fully",
      label: "Insured",
    },
    {
      icon: MapPin,
      number: "Local",
      label: "Expert Engineers",
    },
  ];

  return (
    <section className="py-10 md:py-14 bg-foreground">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-3 gap-4 md:gap-16 max-w-3xl mx-auto">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div key={index} className="text-center animate-fade-in" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-accent/20 flex items-center justify-center mx-auto mb-3">
                  <Icon className="w-6 h-6 md:w-7 md:h-7 text-accent" />
                </div>
                <div className="text-2xl md:text-3xl font-extrabold text-background mb-1">{stat.number}</div>
                <div className="text-xs md:text-sm text-background/70 font-medium">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBanner;
